import React from 'react';

import { FirstChartSection } from './FirstChartSection';
import { SecondChartSection } from './SecondChartSection';
import ThirdChartSection from './ThirdChartSection';
import { HeaderSummaryContainer } from '../HeaderSummary';
import { getFormattedSpendWithSymbol } from 'utils/number';
import {
	Wrapper,
	ScrollContainer,
	SummaryWrapper,
} from './BudgetOverview.styles';

export const BudgetOverview = ({
	data,
	selectedIndex,
	selectColumn,
	currencySymbol,
	currency,
	searchItem,
	onDownloadError,
	onDownloadSuccess,
	onDownloadStart,
}) => {
	const spendFormatter = (value, withZero) =>
		value || withZero
			? getFormattedSpendWithSymbol(value, currencySymbol).toUpperCase()
			: '-';

	const getAxisTitle = () => `${currency.toUpperCase()} (${currencySymbol})`;
	const thirdChartTotal =
		selectedIndex != null
			? data.monthlyVariance[selectedIndex]
			: data.overallVariance;
	const filterModel = { primaryFilter: searchItem && searchItem.name };

	return (
		<ScrollContainer>
			<Wrapper>
				<SummaryWrapper>
					<HeaderSummaryContainer
						spendFormatter={spendFormatter}
						filterModel={filterModel}
					/>
				</SummaryWrapper>
				<FirstChartSection
					data={data}
					spendFormatter={spendFormatter}
					axisTitle={getAxisTitle()}
				/>
				<SecondChartSection
					data={data}
					spendFormatter={spendFormatter}
					axisTitle={getAxisTitle()}
					selectedIndex={selectedIndex}
					selectColumn={selectColumn}
				/>
				<ThirdChartSection
					total={thirdChartTotal}
					spendFormatter={spendFormatter}
					axisTitle={getAxisTitle()}
					selectedIndex={selectedIndex}
					searchItem={searchItem}
					onDownloadError={onDownloadError}
					onDownloadSuccess={onDownloadSuccess}
					onDownloadStart={onDownloadStart}
				/>
			</Wrapper>
		</ScrollContainer>
	);
};
